import { Component, Input } from '@angular/core';

export interface SummaryTableItem {
  Totalizador: number;
  Descricao: string;
  PropostasLC: SummaryTableProposal[] | null;
}

export interface SummaryTableProposal {
  Codigo: string;
  Nome: string;
  GC: string;
  CTC: string;
  Representante: string;
  Status: string;
  Valor: number;
  LeadTime: number;
  Responsavel: string;
  AlcadaAnalise?: string;
  AlcadaAprovacao?: string;
}

@Component({
  selector: 'app-summary-table',
  templateUrl: './summary-table.component.html',
})
export class SummaryTableComponent {
  @Input() summaryItems: SummaryTableItem[] = [];
  @Input() type = 'approval';
}



// WEBPACK FOOTER //
// ./src/app/cockpit/component/cockpit/summary-table/summary-table.component.ts